import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { BonusesSection } from '../components/BonusesSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { PricingSection } from '../components/PricingSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { TestimonialsBottom } from '../components/TestimonialsBottom';
import { FaqSection } from '../components/FaqSection';
import { FinalPricingCTA } from '../components/FinalPricingCTA';
import { Footer } from '../components/Footer';
import { StickyCTA } from '../components/StickyCTA';
export function Landing() {
  return <main className="min-h-screen bg-transparent" data-id="element-194">
      <HeroSection data-id="element-195" />
      <ProblemSection data-id="element-196" />
      <SolutionSection data-id="element-197" />
      <FeaturesSection data-id="element-198" />
      <BonusesSection data-id="element-199" />
      <BenefitsSection data-id="element-200" />
      <PricingSection data-id="element-201" />
      <GuaranteeSection data-id="element-202" />
      <TestimonialsBottom data-id="element-203" />
      <FaqSection data-id="element-204" />
      <FinalPricingCTA data-id="element-205" />
      <Footer data-id="element-206" />
      <StickyCTA data-id="element-207" />
    </main>;
}